import React from 'react';
import { Stack, Typography, Box, Chip, TableRow, TableCell, useTheme } from '@mui/material';
import { TrendingUp } from '@mui/icons-material';
import { CHART_VIEWS } from './ItemAnalytics';

function Insight({ 
    insight,
    chartView, 
    rank,
    onInsightClick
}) {
    const theme = useTheme();
    
    // Get appropriate color based on activity type
    const getActivityColor = () => {
        if (chartView === CHART_VIEWS.PICKLIST_VIEW) {
            if (insight.activityType === 'run') return theme.palette.analytics.cardTypes.run;
            if (insight.activityType === 'restock') return theme.palette.analytics.cardTypes.restock;
            if (insight.activityType === 'trashed') return theme.palette.analytics.cardTypes.openNotUsed;
        } else {
            if (insight.activityType === 'used') return theme.palette.analytics.cardTypes.used;
            if (insight.activityType === 'picked') return theme.palette.analytics.cardTypes.picked;
        }
        return '#1976d2'; // Default blue
    };
    
    const activityColor = getActivityColor();

    return (
        <TableRow 
            key={insight.id}
            hover
            onClick={() => onInsightClick?.(insight)}
            sx={{
                backgroundColor: insight.isHighImpact ? `${activityColor}04` : 'transparent',
                cursor: 'pointer'
            }}
        >
            <TableCell>
                <Box
                    sx={{
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                        backgroundColor: activityColor,
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 600,
                        fontSize: '0.75rem'
                    }}
                >
                    {rank}
                </Box>
            </TableCell>
            <TableCell>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography 
                        variant="body2" 
                        sx={{ 
                            fontWeight: 500,
                            color: insight.isHighImpact ? activityColor : 'text.primary'
                        }}
                    >
                        {insight.title}
                    </Typography>
                    {insight.isHighImpact && (
                        <TrendingUp sx={{ fontSize: 16, color: activityColor }} />
                    )}
                </Stack>
            </TableCell>
            <TableCell>
                <Typography 
                    variant="body2" 
                    color="text.secondary" 
                    sx={{ textTransform: 'capitalize' }}
                >
                    {insight.section}
                </Typography>
            </TableCell>
            <TableCell>
                <Chip
                    label={insight.activityType}
                    size="small"
                    sx={{
                        backgroundColor: activityColor,
                        color: 'white',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        textTransform: 'capitalize'
                    }}
                />
            </TableCell>
            <TableCell align="right">
                <Typography 
                    variant="body2" 
                    sx={{ 
                        fontWeight: 600,
                        color: insight.isHighImpact ? activityColor : 'text.primary'
                    }}
                >
                    {insight.value.toLocaleString()}
                </Typography>
            </TableCell>
            <TableCell align="right">
                <Chip
                    label={`${insight.percentage.toFixed(1)}%`}
                    size="small"
                    sx={{
                        backgroundColor: `${activityColor}20`,
                        color: activityColor,
                        fontWeight: 600,
                        fontSize: '0.75rem'
                    }}
                />
            </TableCell>
        </TableRow>
    );
}

export default Insight;